import { toJS } from 'mobx';
export { observe, toJS } from 'mobx';
export * from './api/hooks.js';
export * from './api/index.js';
export * from './fetch.js';
export * from './hooks/useDebounce.js';
export { HotseatBackend, } from './hotseat/HotseatBackend.js';
export * from './queryClient.js';
export { GameSuiteProvider, typedHooks, useGameSuite, withGame, } from './suite/GameSuiteContext.js';
export { useCreateGameSuite } from './suite/useCreateGameSuite.js';
export * from './types.js';
export * from './useStorage.js';
export { nonce };
import nonce from './nonce.js';
if (window.__game_client_nonce__ &&
    window.__game_client_nonce__ !== nonce) {
    console.error('Nonce mismatch! This is likely due to a hot reload. Please refresh the page.', `Expected nonce: ${nonce}, but found: ${window.__game_client_nonce__}`);
}
window.__game_client_nonce__ = nonce;
window.toJS = toJS; // for debugging
//# sourceMappingURL=index.js.map